// extracted by mini-css-extract-plugin
export default {"actionCard":"ActionDisplay_actionCard__8qYLD"};